import React from "react";
import { Grid } from "@mui/material";
import TextFieldComponent from "./textField";

/**
 * Fields configuration for the address component.
 * This array is used to dynamically generate fields in the component.
 * Each object in the array represents a field with its properties.
 * @type {Array<{ label: string, value: string, disabled?: boolean, col?: number, id: string }>}
 */
const addressFieldsConfig = [
  {
    id: "to-name",
    label: "To",
    value: "name",
    col: 6,
  },
  {
    id: "address",
    label: "Address",
    value: "address",
    disabled: true,
    col: 6,
  },
  {
    id: "address-2",
    label: "Address 2 (If Applicable)",
    value: "address_2",
    col: 6,
  },
  {
    id: "city",
    label: "City",
    value: "city",
    col: 6,
  },
  {
    id: "state-province",
    label: "State / Province",
    value: "state_province",
    col: 6,
  },
  {
    id: "zipcode",
    label: "Zipcode",
    value: "zipcode",
    col: 6,
  },
  {
    id: "country",
    label: "Country",
    value: "country",
    col: 6,
  },
  {
    id: "phone",
    label: "Phone Number",
    value: "phone",
    col: 6,
  },
];

/**
 * AddressComponent displays address-related information in a grid layout.
 * It uses a configuration array to dynamically render fields.
 * Each field can have properties like label, value, and column width.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.order - The order object containing address details.
 * @returns {JSX.Element} A grid of text fields displaying address details.
 */
const AddressComponent = (props) => {
  const { order } = props;

  return (
    <Grid container spacing={2} style={{ margin: "8px" }}>
      {addressFieldsConfig.map((field) => (
        <Grid item xs={12} sm={field.col || 6} key={field.id}>
          <TextFieldComponent
            label={field.label}
            value={order[field.value] || ""}
            disabled={field.disabled}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AddressComponent;
